import { IRootState } from '../../../store'
import { IPatientDemographicsOptionsState } from '../store/options.types'

export const getPatientDemographicsOptionsSelector = (state: IRootState): IPatientDemographicsOptionsState =>
  state.options.patientDemographicsOptions
